import React from 'react';
import {Col} from 'react-bootstrap';
// src
import {ORDERS_SUMMARY_PATH} from '../../routes/routes_production.js';
import {PostRequest} from '../../api/PostRequest.js';
import PageHeader from '../PageHeader.js';
import OrdersTable from './OrdersTable.js';
import OrdersPager from './OrdersPager.js';
// css
import './styles/summaryStyles.css';

class Summary extends React.Component {
  render() {
    return(
      <React.Fragment>        
        <Col xs={12}>
          <OrderSummary      
            title="I miei ordini" 
            subTitle="Seleziona un ordine per vedere o modificare i suoi dati"
            request="getOrders" page={1} rowsPerPage={25} enableEdit={true}
          />
        </Col>

      <Col xs={12}>
        <OrderSummary      
          title="Ordini dei collaboratori" 
          subTitle="Seleziona un ordine per vedere i suoi dati"
          request="getSubOrders" page={1} rowsPerPage={25} enableEdit={true}
        />
      </Col>
    </React.Fragment>
    );
  }
}

/* TODO@lu:    
  -selezione scelta nr di righe visibili
*/

class OrderSummary extends React.Component {
  constructor() {
    super();

    this.state = {           
      orders: null, 
      loading: true,  
    }
  }

  /**
   * Ritorna il numero di pagine in base al totale degli ordini 
   * e al numero di questi mostrati per pagina
   *
   * @param orders array di objects, ogni object è un ordine
   */
  calculateNrOfPages = (orders) => {
    const {rowsPerPage} = this.props;
    const nrOfOrders = orders.length;
    
    return Math.ceil(nrOfOrders/rowsPerPage);   
  }

  /**
   * Cambia il numero di pagina corrente
   */
  handleChangePage(page) {    
    this.setState({page});
  }

  /**
   * Acquisisce gli ordini inseriti dall'operatore corrente
   * e li salva in state.orders come array di objects, ogni object è un ordine
   */
  componentDidMount() {         
    let params = {
      "request": this.props.request, 
      "serialeOperatore": localStorage.getItem('serialeOperatore'),
      //"page": this.props.page,
      //"rowsPerPage": this.props.rowsPerPage
    };  
    
    PostRequest(ORDERS_SUMMARY_PATH, params)
      .then((res) => {   
        let noOrders = (res.status_code !== undefined && res.status_code === 404);

        this.setState({
          loading: false,      
          page: this.props.page,
          orders: (noOrders)? null : res,                    
          nrOfPages: (noOrders)? 0: this.calculateNrOfPages(res),          
        });       
      })
      .catch((err) => console.log(err));
  }

  render() {
    if(this.state.loading) return null;
    const { orders, page, nrOfPages } = this.state;
    
    return(
      <Col xs={12}>
        <PageHeader title={this.props.title} subTitle={this.props.subTitle} />                     

        <OrdersTable orders={orders} page={page} rowsPerPage={this.props.rowsPerPage} 
                     enableEdit={this.props.enableEdit} />     

        {(orders===null)? null : 
          <OrdersPager 
            page={page} 
            pages={nrOfPages} 
            handleChangePage={this.handleChangePage.bind(this)} 
          />      
        }
      </Col>
    );
  }
}

export default Summary;


// WEBPACK FOOTER //
// ./src/cmp/Summary/Summary.js